
const visitor = {
	state: () => ({
		visitorID: (() => {
			return '';
		})(),
		isUserLoggedIn: (() => {
			return document.documentElement.getAttribute('data-is-logged-in') || 'False';
		})(),
		isHcpUser: (() => {
			return document.documentElement.getAttribute('data-is-hcp-user') || 'False';
		})(),
		userJustLoggedIn: false,
		loginInitiatedFrom: '',
	}),
	getters: {
		getVisitorID: (state) => {
			return state.visitorID;
		},
		getIsUserLoggedIn: (state) => {
			return /^true$/i.test(state.isUserLoggedIn);
		},
		getIsHcpUser: (state) => {
			return /^true$/i.test(state.isHcpUser);
		},
		getUserJustLoggedIn: (state) => {
			return state.userJustLoggedIn;
		},
		getLoginInitiatedFrom: (state) => {
			return state.loginInitiatedFrom;
		},
	},
	mutations: {
		setUserJustLoggedIn: (state) => {
			state.userJustLoggedIn = true;
		},
		setLoginInitiatedFrom: (state, value) => {
			state.loginInitiatedFrom = value;
		},
	},
}

export default visitor;
